import React from 'react';
import Navbar from '../components/main/Navbar';
import Footer from '../components/main/Footer';
import { Outlet } from 'react-router-dom';
import '../assets/styles/Layout.css'; // import your CSS

import logo from '../assets/images/MagunexLogo.jpeg'; // Import the logo

const AuthLayout = () => {
    return (
        <div className="d-flex flex-column h-100">
            {/* Main Content - 86vh */}
            <main className="main-content-area flex-grow-1 overflow-auto">
                <Outlet />
            </main>

            {/* Footer - 6vh */}
            <div className='footer text-dark'>

                <footer className="footer bg-light text-center py-4">
                    <div className="container">
                        <div className="d-flex justify-content-center flex-column flex-md-row">
                            <p className="mb-0 me-3">© {new Date().getFullYear()} Magunex. All rights reserved.</p>
                            <p className="mb-0 me-3">
                                <a href="/privacy-policy" className="text-decoration-none">Privacy Policy</a>
                            </p>
                            <p className="mb-0 me-3">|</p>
                            <p className="mb-0 me-3">
                                <a href="/terms-of-service" className="text-decoration-none">Terms of Service</a>
                            </p>
                            <p className="mb-0">Contact us: <a href="mailto:support@magunex.com">support@magunex.com</a></p>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default AuthLayout;
